// CheckedInReminder.style.ts
import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, black, denim, grayscale, white} from '/theme/color/on.color';
import {alto, codGray, wineRed} from '/theme/color/secondary.color';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 0,
    // marginHorizontal: indent * 0.8,
    marginVertical: indent * 2.4,
  },
  header: {
    fontWeight: '600',
    marginBottom: indent * 0.8,
  },
  titleText: {
    color: black,
  },
  reminderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: alabaster,
    paddingHorizontal: indent * 0.4,
    paddingVertical: indent * 0.8,
    borderRadius: 8,
    borderColor: alto,
    borderWidth: 1,
  },
  iconContainer: {
    width: 24,
    height: 24,
    marginHorizontal: indent * 0.2,
  },
  selectedIcon: {
    fontSize: 22,
    color: denim,
  },
  unSelectedIcon: {
    borderColor: grayscale,
    borderStyle: 'solid',
    borderWidth: 2.5,
    borderRadius: 2,
    color: white,
  },
  labelsContainer: {
    flex: 1,
    marginLeft: indent * 0.5,
  },
  labelDate: {
    fontWeight: '600',
    color: codGray,
  },

  pastLabelDate: {
    fontWeight: '600',
    color: wineRed,
  },

  labelRepeat: {
    marginTop: indent * 0.2,
    color: codGray,
  },
  loader: {
    marginTop: indent * 2,
  },
});

export default styles;
